// Representative vehicle imagery (clearly labelled as representative in the UI).
// Mapped by make so the brand is recognisable regardless of exact model.
import logoFull from "../assets/atlas-logo-official.png";
import logoNav from "../assets/atlas-wordmark.png";

export const LOGO_FULL = logoFull;
export const LOGO_NAV = logoNav;

export const HERO_IMAGE =
  "https://images.pexels.com/photos/5982898/pexels-photo-5982898.jpeg?auto=compress&cs=tinysrgb&w=1920";

const IMG = {
  "BMW": "https://images.unsplash.com/photo-1594051673969-172a6f721d3c?w=800&q=70",
  "Mercedes-Benz": "https://images.unsplash.com/photo-1582828715181-338a8e04ba53?w=800&q=70",
  "Audi": "https://images.unsplash.com/photo-1542282088-72c9c27ed0cd?w=800&q=70",
  "Volvo": "https://images.unsplash.com/photo-1629896428945-349a9a86e6ba?w=800&q=70",
  "Volkswagen": "https://images.unsplash.com/photo-1572811298797-9eecadf6cb24?w=800&q=70",
  "Toyota": "https://images.unsplash.com/photo-1626072557464-90403d788e8d?w=800&q=70",
  "Mazda": "https://images.unsplash.com/photo-1599491143816-8c1ea12a4e06?w=800&q=70",
  "Honda": "https://images.pexels.com/photos/25637367/pexels-photo-25637367.jpeg?auto=compress&cs=tinysrgb&w=800",
  "Cupra": "https://images.unsplash.com/photo-1781730908678-b1469b9bd1e2?w=800&q=70",
};

const FALLBACK = "https://images.unsplash.com/photo-1542282088-72c9c27ed0cd?w=800&q=70";

export const vehicleImage = (vehicle) => IMG[vehicle?.make] || FALLBACK;
